var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.title
      ? _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900" },
          [_vm._v(" " + _vm._s(_vm.title) + " ")]
        )
      : _vm._e(),
    _vm.body
      ? _c(
          "p",
          { staticClass: "mt-1 max-w-2xl text-sm leading-5 text-gray-500" },
          [_vm._v(" " + _vm._s(_vm.body) + " ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }